import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import type { TagDto } from '@/api';

interface TermsProps {
  terms: TagDto[]
  truncated?: boolean
}


const MAX_TERMS = 1
const CLOSE_DELAY = 1000

export default /*#__PURE__*/_defineComponent({
  __name: 'Terms',
  props: {
  terms: null,
  truncated: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;





let isInTooltip = _ref(false);
let tooltipVisible = _ref(false);
let isInPlusTag = _ref(false);

const isTruncated = _computed(() => props.truncated && props.terms.length > MAX_TERMS);
const truncatedTerms = _computed(() => (props.truncated ? props.terms.slice(0, MAX_TERMS) : props.terms));
const otherTerms = _computed(() => (props.truncated ? props.terms.slice(MAX_TERMS) : []));
const plusTerm = _computed(() => ({ id: 'plus', name: `+${props.terms.length - MAX_TERMS}` }));

const openTooltip = () => {
  tooltipVisible.value = true;
  isInTooltip.value = false;
  isInPlusTag.value = true;
};

const closeTooltip = () => {
  isInPlusTag.value = false;
  setTimeout(() => {
    if (!isInTooltip.value) tooltipVisible.value = false;
  }, 400);
};

const handleMouseEnter = () => {
  isInTooltip.value = true;
  tooltipVisible.value = true;
  isInPlusTag.value = false;
};

const handleMouseLeave = () => {
  isInTooltip.value = false;
  setTimeout(() => {
    if (!isInPlusTag.value) tooltipVisible.value = false;
  }, CLOSE_DELAY);
};


return { __sfc: true,MAX_TERMS, CLOSE_DELAY, props, isInTooltip, tooltipVisible, isInPlusTag, isTruncated, truncatedTerms, otherTerms, plusTerm, openTooltip, closeTooltip, handleMouseEnter, handleMouseLeave, _ref, _computed }
}

})